import React, { Component }      from 'react';
import { connect }               from 'react-redux';
import { Modal }                 from 'react-bootstrap';
import {Field, reduxForm, reset} from 'redux-form';
import Dropzone                  from 'react-dropzone';
import $ from 'jquery';
import validate                  from '../../../../service/validate_nave';
import {SetLikePostUser,
        GetTipoMidiaPost,
        GetQtdCommentPostTurma,
        GetRemoverPostTurma,
        GetRegistroPostTurma,
        SendPublic,
        SetValidUrlYoutube,
        ClearUrl,
        }                       from '../../../../actions/turmaAction';
import TripulacaoComentario     from './tripulacao_comentario';
import {SetError}               from '../../../../actions/notificacaoAction'; 
import RenderAvatarP            from '../../../../container/render_avatar_p'
import RenderAvatarM            from '../../../../container/render_avatar_m'
import BtAcaoComentario         from '../../../../container/btAcaoRemoverItem';
import BtLikePost               from '../../../../container/bt_like_hud';
import BtComentarioNave         from '../../../../container/bt_comentario_hud';
import TimeLineItem             from '../../../../container/renderHudTimeLine';
import FlashRetornoNulo         from '../../../../container/FlashRetornoNulo';
import RenderPrevImg            from '../../../../container/renderPrevImagemTimeLine'; 
import RenderFormTextVideo      from '../../../../container/renderFormTextVideo';
import Foto                     from '../../../../img/comunication/avatar/christian.png';
import '../../../../css/aluno/box.css';

const renderField = ({ input, label,length, type, placeholder,value,meta: { touched, error } }) => (

        <textarea 
                className="form-control" 
                rows="2"
                placeholder={placeholder} 
                {...input}></textarea>
    )



class TripulacaoTimeLine extends Component {

    constructor(props){

        super(props);
        this.state = {
                        like             : "#AAB8BE",
                        ItemPostTimeline : [],
                        showModal        : false,
                        load             : false,
                        tur_id           : ( this.props.session.turma ?  this.props.session.turma : this.props.tur_id),
                        publicImg        : false,
                        publicMov        : false,
                        buttonDisabled   : false,
                        validMov         : false,
                        publicText       : "",
                        video            : "",
                        errors           : {},
                        use_id           : this.props.session.id,
                        per_id           : this.props.session.perfil,
                        post_tipo        : 1,
                        files            : null,
                        textButtonPublic : "Publicar"
                      }
        this.onChange      = this.onChange.bind(this);
        this.onChangeVideo = this.onChangeVideo.bind(this);
        this.PublicMovie   = this.PublicMovie.bind(this);     
                    
    }

    PublicMovie(){
      this.setState({publicMov:true,publicImg:false});
    }  

    onDrop(files) {
      this.setState({selectedImg:files[0].preview,files:files,publicImg:true,publicMov:false,post_tipo:2});
    }

    removeImgSelect(){
     this.setState({selectedImg:[],publicImg:false,post_tipo:1,files:null})
    }
  
    removeMovSelect(){
     this.setState({publicMov:false,post_tipo:1,video: "",validMov:false})
    }

    onChange(e) {
     this.setState({publicText: e.target.value,errors:{}});
    }

    onChangeVideo(e) {

        const retValid =  this.props.SetValidUrlYoutube(e.target.value);
        this.setState({ 
                        video     : (retValid === 1 ? e.target.value:""),
                       // validMov  : (retValid === 1 ? false:true),
                        post_tipo : (retValid === 1 ? 3:1)
                      });
   
        if (retValid) {
                $('.valid-url').html("");
        } else {
                $('.valid-url').html('<div> <h6>Copie e cole uma url válida do Youtube.</h6> </div>');
        }
       
    }

    statesComponente(){
      this.setState({ textButtonPublic:"Publicar",buttonDisabled:false,publicText:"",validMov:false});
      this.props.initialize({publicText:""});
    }

    handleSubmit(e) {
         
        this.setState({ textButtonPublic:"Enviando...",buttonDisabled:true});   
        const dados   = {
                         tur_pos_cod_turma   : this.state.tur_id,
                         tur_pos_cod_usuario : this.state.use_id,
                         tur_pos_tipo        : this.state.post_tipo,
                         tur_pos_midia       : (this.state.post_tipo === 3 ? this.props.ClearUrl(e.video) : "" ),
                         tur_pos_post        : e.publicText
                        }                            
        this.props.SendPublic(dados,this.state.files).then((response) =>{
            this.statesComponente();
            this.removeMovSelect();       
            this.removeImgSelect();       
        }).catch((error)=>{
            this.statesComponente();
            this.props.SetError(500);
        });

    }

    close(){
      this.setState({showModal: false,ItemPostTimeline:[]});
    }

    open(val) {
       this.setState({  
          showModal        : true,
          ItemPostTimeline : this.props.allPostsTurma[val],
          vetor            : val
        });
    }

    excluirPostTurma(id){

        const acao  = window.confirm("Deseja Remover?");
        if (acao) {
            this.props.GetRemoverPostTurma(this.props.session.id,id);
        }
    }  

    likePost(val){
       // Função que adiciona like do post da nave 
       this.props.SetLikePostUser(val,this.props.session.id);
    } 

    renderListItemPosts(){
         // Função que lista todos os posts da nave
         const retornoListaItem = this.props.allPostsTurma;
     
         if (retornoListaItem.length>0) {

                return retornoListaItem.map((elem,i)=>{

                    //Componente gerador botao de like    
                    const btLike       = <BtLikePost vetor={i} funcao={this.likePost.bind(this,elem.tur_pos_id)}/>;
                     //Componente gerador botao de comentario
                    const btComentario = <BtComentarioNave vetor={i} funcao={this.open.bind(this,i)}/>;
                 

                    return  <TimeLineItem
                                key          = {i}
                                id           = {elem.tur_pos_id}
                                foto         = {elem.use_foto}
                                nome         = {elem.use_nome}
                                btAcao       = {elem.tur_pos_cod_usuario === this.props.session.id ? <BtAcaoComentario funcao={this.excluirPostTurma.bind(this,elem.tur_pos_id)}/> : ""}
                                dataCriado   = {elem.created_at}
                                postConteudo = {elem.tur_pos_post}
                                midia        = {elem.tur_pos_midia}
                                tipo         = {elem.tur_pos_tipo}
                                postMidia    = {<div dangerouslySetInnerHTML={{__html: this.props.GetTipoMidiaPost(elem)}} />}
                                btLike   = { btLike }
                                btComentario   = { btComentario }
                                />  
                });

                }else{

                    return <FlashRetornoNulo text="Seja o primeira a publicar na nave."/>
                }
    }

    render() {
      
          const {handleSubmit} = this.props;
        return (
            <div className="communication">
                <div className="communication-new">
                    <div className="author author-with-link author-with-line author-with-line-half author-with-line-marker">
                        {/* <div className="author-instance">
                            <RenderAvatarM Foto={Foto}></RenderAvatarM>
                        </div> */}
                        <div className="author-avatar">
                            <RenderAvatarP Foto={this.props.session.foto}/>     
                        </div>
                    </div>
                   <form className="communication-new-input communication-container-box communication-new-input-link" onSubmit={handleSubmit(this.handleSubmit.bind(this))}>
                        <div className="communication-container-box-left">
                            <Field name="publicText" type="textarea" component={renderField} label="" placeholder="Criar uma publicação"/> 
                        </div>
                        <div className="communication-container-box-right">
                            <div className="communication-container-box-info">{!this.props.fet_turma? "Carregando...": `TURMA ${this.props.fet_turma.tur_id_totvs}`}</div>
                            <div className="communication-container-box-actions">
                                <button type="submit" className="communication-container-box-action">
                                    <span>Enviar</span>
                                </button>
                                <div className="communication-container-box-tools">
                                  <Dropzone className="action action-icon action-simple" multiple={false} accept="image/png,image/jpeg" onDrop={this.onDrop.bind(this)}>
                                        <i className="gamefica-icon gamefica-photo"></i>
                                    </Dropzone>
                                    <a href={void(0)} className="action action-icon action-simple" onClick={this.PublicMovie}>
                                        <i className="gamefica-icon gamefica-video"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </form>
                    
                </div>
                <div className="communication-messages hud-scroll-tip">

                   {this.state.publicImg ? <RenderPrevImg prevImg={this.state.selectedImg} funcao={this.removeImgSelect.bind(this)}/>:""} 
                   {this.state.publicMov ? 
                        <Field 
                            name="video" 
                            type="text" 
                            component={RenderFormTextVideo} 
                            placeholder="Criar uma publicação" 
                            funcao={this.removeMovSelect.bind(this)} 
                            onChange= {this.onChangeVideo}/>:
                            "" }
                    {this.renderListItemPosts()}
                </div>
                <Modal show={this.state.showModal}  bsSize="lg">
                   <TripulacaoComentario tur_id={this.state.tur_id} funcao={this.close.bind(this)} ItemPostTimeline={this.state.ItemPostTimeline}/> 
                </Modal>
            </div>
            );
    }
}

const afterSubmit = (result, dispatch) => dispatch(reset('form'));

function  mapStateToProps(state){
    return {
             session       : state.auth.session,
             allPostsTurma : state.turmaReducer.all_posts,
             fet_turma     : state.turmaReducer.turma,
             all_likes     : state.turmaReducer.all_likes,
             actionModal   : state.scopoReducer.actionModal,
             feth_tur_id   : state.turmaReducer.fetch_tur_id
    }
}

export default reduxForm({
   form                     : 'post_nave', //                 <------ same form name
   destroyOnUnmount         : true, //        <------ preserve form data
   forceUnregisterOnUnmount : true, // <------ unregister fields on unmount
   onSubmitSuccess          : afterSubmit,
  validate
})(connect(mapStateToProps,{SetLikePostUser,GetTipoMidiaPost,GetQtdCommentPostTurma,GetRemoverPostTurma,SendPublic,SetValidUrlYoutube,GetRegistroPostTurma,ClearUrl,SetError})(TripulacaoTimeLine));




// WEBPACK FOOTER //
// ./src/components/aluno/comunicacao/tripulacao/tripulacao_timeLine.js